<template>
    <div><slot name="activator" :attrs="{}" :on="{ click }" /></div>
</template>

<script>
export default {
    methods: {
        click() {
            alert("사용할 수 없는 기능입니다");
        },
    },
};
</script>

<style>
</style>